// Batches cart-error pubsub events and forwards them to the GTM dataLayer.
// Previously imported the full RxJS bundle from unpkg.com at runtime just to
// buffer and dedupe these events.
(() => {
    try {
        const subscribe = window.subscribe
        const dataLayer = window.dataLayer || []

        if (typeof subscribe !== 'function') return

        const handleCartError = (event) => {
            const { action, source, error, context } = event || {}
            if (action === 'create' && source === 'auto-add') {
                dataLayer.push({
                    event: 'autoAddError',
                    errorMessage: error && error.message,
                    context
                })
            }
        }

        let buffer = []
        let flushTimer = null
        let lastBatchJson = null

        const flush = () => {
            flushTimer = null
            if (buffer.length === 0) return
            const batch = buffer
            buffer = []
            // Drop a batch identical to the previous one (matches the old
            // distinctUntilChanged behavior).
            const batchJson = JSON.stringify(batch)
            if (batchJson === lastBatchJson) return
            lastBatchJson = batchJson
            batch.forEach(handleCartError)
        }

        subscribe('cart-error', (data) => {
            buffer.push(data)
            if (!flushTimer) flushTimer = setTimeout(flush, 1000)
        })
    } catch (error) {
        console.error(error)
    }
})()
